export default __webpack_public_path__ + "static/media/stats-times-facilitator.c19743d1.svg";